module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Title_Page"
  }, [_c('h2', {
    staticClass: "chaptitle2"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Contents#ch1",
      "id": "rch1"
    }
  }, [_c('b', [_vm._v("You’re My Inspiration")])])]), _vm._v(" "), _c('p', {
    staticClass: "sub2"
  }, [_c('b', [_vm._v("We begin this epic journey into the Weird Zone with the inspirations behind some of the most iconic bad guys (and things) in TV and movie history.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("ALIEN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the late 1970s, screenwriter Dan O’Bannon read an article about the spider wasp, a bee that reproduces by paralyzing a spider and then laying its eggs on the spider’s abdomen. When the bee larvae hatch, they eat right through the still-living spider. This macabre image haunted O’Bannon’s dreams for years, but from them he was able to form the basis for the insectlike alien creature that became one of Hollywood’s all-time most-feared monsters.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("PATRICK BATEMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the 2000 movie "), _c('i', [_vm._v("American Psycho")]), _vm._v(", Christian Bale portrayed Patrick Bateman, a stockbroker by day, sociopathic serial killer by night. Bale based his characterization on another actor. According to director Mary Harron, “he had been watching Tom Cruise on David Letterman, and he just had this very intense friendliness with nothing behind the eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p16-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("GOLLUM")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Actor Andy Serkis provided the voice and movements for the character in The Lord of the Rings films. He based the voice on the sound of his cat coughing up a hairball. Special effects artists modeled Gollum’s wiry, bony frame on punk rocker Iggy Pop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("WALTER WHITE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Breaking Bad")]), _vm._v(" creator Vince Gilligan was inspired by a 1952 Japanese film by Akira Kurosawa called "), _c('i', [_vm._v("Ikuru")]), _vm._v(", about, says Gilligan, “a midlevel corporate guy who finds out he’s dying of cancer. And in the last months of his life what he chooses to do is a very good thing, it’s to build a playground in Tokyo.” (Walter White, however, takes a more “methy” path.)")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/img_p16-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_c('b', [_vm._v("DR. EVIL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mike Myers’s inspiration for Austin Powers’s archenemy comes from the James Bond villain, Blofeld, in "), _c('i', [_vm._v("You Only Live Twice")]), _vm._v(". But Dr. Evil’s famous mannerism comes from this 1979 photograph of Rolling Stones guitarist Keith Richards.")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('b', [_vm._v("LONELY PARROTS CAN GO INSANE.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e799d20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Chapter1.vue
// module id = 81
// module chunks = 0